import React from 'react';
import { Box } from '@mui/material';

interface Field {
  label: string;
  value: any;
}

export interface Props {
  fields?: Field[];
  children?: any;
  style?: any;
}

const AssignmentFieldInfo = ({ label, value }: { label: string; value: any }) => (
  <Box mr={4} display="flex">
    <Box fontWeight="fontWeightBold" pr={1}>
      {label}:
    </Box>
    <Box>{value}</Box>
  </Box>
);

const AssignmentDetails = ({ fields, children, ...props }: Props) => {
  return (
    <Box display="flex" alignItems="center" {...props}>
      {fields?.map(({ label, value }, idx) => (
        <AssignmentFieldInfo key={idx} label={label} value={value} />
      ))}
      {children}
    </Box>
  );
};

export default AssignmentDetails;
